// This file provides a type-safe wrapper around Recharts components
// to avoid React 18 type compatibility warnings

import {
  Bar as RechartsBar,
  BarChart as RechartsBarChart,
  CartesianGrid as RechartsCartesianGrid,
  Cell as RechartsCell,
  Legend as RechartsLegend,
  Line as RechartsLine,
  LineChart as RechartsLineChart,
  Pie as RechartsPie,
  PieChart as RechartsPieChart,
  ResponsiveContainer as RechartsResponsiveContainer,
  Tooltip as RechartsTooltip,
  XAxis as RechartsXAxis,
  YAxis as RechartsYAxis,
} from "recharts";

// Re-export with type assertions to avoid React 18 compatibility warnings
export const ResponsiveContainer = RechartsResponsiveContainer as any;
export const BarChart = RechartsBarChart as any;
export const LineChart = RechartsLineChart as any;
export const PieChart = RechartsPieChart as any;
export const CartesianGrid = RechartsCartesianGrid as any;
export const XAxis = RechartsXAxis as any;
export const YAxis = RechartsYAxis as any;
export const Tooltip = RechartsTooltip as any;
export const Legend = RechartsLegend as any;
export const Bar = RechartsBar as any;
export const Line = RechartsLine as any;
export const Pie = RechartsPie as any;
export const Cell = RechartsCell as any;
